/**
 * OPAQUE index strings — nothing downstream parses one apart. An entry collects
 * more of them as sources agree on what it is: an optimistic user message starts
 * under its client turn id and gains its artifact key when the POST echoes one.
 */

export const artifactKey = (artifactId: string): string => `artifact:${artifactId}`;

export const turnMessageKey = (turnId: string, position: number): string =>
  `turn:${turnId}:${position}`;

/** `message_index` is TURN-scoped and stamped 0 on every iteration, so the
 *  iteration must be part of the identity or a tool turn's iterations collapse
 *  into one entry. */
export const streamMessageKey = (
  turnId: string,
  iteration: number,
  messageIndex: number
): string => `stream:${turnId}:${iteration}:${messageIndex}`;

/** For a stream carrying no identity at all: a store-local slot. */
export const streamSlotKey = (slot: number): string => `slot:${slot}`;

export const toolKey = (toolCallId: string): string => `tool:${toolCallId}`;

/** Old-backend fallback. Sound only because `messages[]` is append-only within a
 *  chat lifetime. */
export const snapshotPositionKey = (index: number): string => `snapshot:${index}`;

export const failureKey = (eventId: string): string => `failure:${eventId}`;
